export function pickCombinedFlowchartVersion(versions) {
  const list = Array.isArray(versions) ? versions : [];

  const publishedActive = list.find((version) => {
    const status = String(version?.status ?? '').trim().toLowerCase();
    return status === 'published' && version?.isActive === true;
  });
  if (publishedActive) return publishedActive;

  const drafts = list
    .filter((version) => String(version?.status ?? '').trim().toLowerCase() === 'draft')
    .sort((a, b) => (Number(b?.value) || 0) - (Number(a?.value) || 0));

  return drafts[0] || null;
}

export function combinedVersionLabel(version) {
  if (!version) return '';
  const number = Number(version.value);
  const versionText = Number.isFinite(number) ? `v${number}` : 'Version';
  const status = String(version.status ?? '').trim().toLowerCase();
  if (status === 'published' && version.isActive) {
    return `${versionText} · Published (active)`;
  }
  if (status === 'draft') {
    return `${versionText} · Draft`;
  }
  return version.label || versionText;
}
